import Cookies from 'js-cookie';
import axios from 'axios';
import actions from './actions';
import { API_HOST, API } from '../../config/api';
import { setRefreshToken, setToken } from '../../services/authenticationService';
import actionsAlert from '../alert/actions';

const { loginSuccess, logoutSuccess } = actions;
const { alertError } = actionsAlert;

/* login */
const login = (idToken, notificationToken, history, stay) => {
  return async dispatch => {
    const URL = API_HOST + API.auth.login;
    axios.post(URL, { idToken, notificationToken }).then(
      res => {
        setToken(res.data.token);
        setRefreshToken(res.data.refreshToken);
        if (stay === true) {
          Cookies.set('logedIn', true, { expires: 365 });
          Cookies.set('token', res.data.token, { expires: 365 });
        } else {
          Cookies.set('logedIn', true);
          Cookies.set('token', res.data.refreshToken);
        }
        history.push('/admin');
        return dispatch(loginSuccess(true));
      },
      err => {
        if (err.response.data.message) dispatch(alertError({ msg: err.response.data.message, type: 'error' }));
        else dispatch(alertError({ msg: "Erreur d'authentification", type: 'error' }));
      },
    );
  };
};

/* logout */
const logOut = () => {
  return async dispatch => {
    try {
      Cookies.remove('logedIn');
      Cookies.remove('token');
      dispatch(logoutSuccess(null));
    } catch (err) {
      console.error('Error during logout:', err);
    }
  };
};

export { login, logOut };
